import React from 'react';
import Radium from 'radium';

import styles from './styles';

const UTCheck = ({ style }) => (
  <div>
    <svg height="15px" width="15px" style={[styles.checkedOk, style]}>
      <polyline points="3,8 6,11 13.5,3.5" />
    </svg>
  </div>
);

export default Radium(UTCheck);
